import { useLazyQuery } from "@apollo/client/react";import moment from 'moment';
import 'moment/locale/es';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import './documentsSearchContent.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { Checkbox, FormControl, Grid, InputAdornment, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { DateInput } from '../../../components/dateInput/DateInput';
import { CustomButton } from '../../../components/customButton/CustomButton';

import { GET_DELEGACIONES_BY_USUARIO } from '../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario';
import { GET_USUARIO_DELEGACION_ORIGEN } from '../../../data/graphQL/queries/usuarios/getUsuarioDelegacionOrigen';
import { GET_DOCUMENTOS_SEARCH } from '../../../data/graphQL/queries/Documentos/getDocumentosSearch';
import { adaptDelegacionArray } from '../../../adapters/delegacionAdapter';
import { adaptDocumentosSearchArray } from '../../../adapters/documento/documentoSearchAdapter';
import { adaptDocumentosSearchExportArray } from '../../../adapters/documento/documentoSearchExportAdapter';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { CustomChip } from '../../../components/chip/Chip';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { usePersistFilters } from '../../../hooks/usePersistFilters';
import { downloadExcel } from '../../../utils/downloadExcel';

const locale = "es-ES";

export const DocumentsSearchContent = ({ setChildrenAction }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [allowedWrite, setAllowedWrite] = useState(false);
  const [documentosSinFiltro, setDocumentosSinFiltro] = useState([]);
  const [documentos, setDocumentos] = useState([]);
  const [documentosExport, setDocumentosExport] = useState([]);

  const header = ["Evaluacion", "Paciente", "Cliente", "FechaDesde", "FechaHasta", "Plan", "Cant. Cnx", "Cnx. PE", "Cnx. VE", "AC", 
      "EV", "C", "RNH", "RFK", "P", "V", "DOC", "PE", "PG", "NT", "FN", "PS", "KN", "TOC", "AS", "PSI"
  ];

  const FILE_TYPE = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];

  // delegaciones
  const [delegaciones, setDelegaciones] = useState([]);
  const [delegacionOrigen, setDelegacionOrigen] = useState(0);

  const txtFiltroGrilla = useRef(null);

  const rutasStorage = localStorage.getItem('navigationRoutes');
  useEffect(() => {
    if (rutasStorage) {
      const rutas = JSON.parse(rutasStorage);
      const rutaQueSirve = location.pathname;
      setAllowedWrite(rutas?.find((ruta) => ruta.aplicaciones.find((app) => app.url == rutaQueSirve)
      )?.aplicaciones?.find((app) => app.url == rutaQueSirve).escritura);

    }
  }, [rutasStorage]);

  const initialFiltersValue = JSON.parse(localStorage.getItem('documentsSearchFilters'));
  const { filters, handleChangeFilters } = usePersistFilters(
    {
      idDelegacion: initialFiltersValue != null ? initialFiltersValue.idDelegacion : delegacionOrigen,
      fechaDesde: initialFiltersValue != null ? initialFiltersValue.fechaDesde : moment().add(-25, 'd').format("yyyy-MM-DD"),
      fechaHasta: initialFiltersValue != null ? initialFiltersValue.fechaHasta : moment().add(5, 'd').format("yyyy-MM-DD"),
      codigoCliente: initialFiltersValue != null ? initialFiltersValue.codigoCliente : "",
      hcPaciente: initialFiltersValue != null ? initialFiltersValue.hcPaciente : "",
      estado: initialFiltersValue != null ? initialFiltersValue.estado : "AT",
      pendienteFacturar: initialFiltersValue != null ? initialFiltersValue.pendienteFacturar : true,
      facturacionAutomatica: initialFiltersValue != null ? initialFiltersValue.facturacionAutomatica : false
    },
    'documentsSearchFilters'
  );

  useEffect(() => {
    if (!delegacionesLoading) {
      getDelegaciones({variables: { idUsuario: JSON.parse(storageId, 10) }});
    }

    if (!delegacionOrigenLoading) {
      getDelegacionOrigen({variables: { idUsuario: JSON.parse(storageId, 10) }});
    }

    handleSearch();
  }, []);

  const storageId = sessionStorage.getItem('idUsuario');
  const [getDelegaciones, { data: dataDelegaciones, loading: delegacionesLoading }] = useLazyQuery(GET_DELEGACIONES_BY_USUARIO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataDelegaciones) return;
    const delegSinTodas = { allDelegacionesByUsuario: dataDelegaciones.allDelegacionesByUsuario.filter((d) => d.idDelegacion != 1) };
    setDelegaciones(adaptDelegacionArray(delegSinTodas));
  }, [dataDelegaciones]);

  const [getDelegacionOrigen, { data: delegacionOrigenData, loading: delegacionOrigenLoading }] = useLazyQuery(GET_USUARIO_DELEGACION_ORIGEN, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!delegacionOrigenData) return;
    if (delegacionOrigenData.usuarioFull.success) {
      const deleg = parseInt(delegacionOrigenData.usuarioFull.valorEsperado.delegacionOrigen, 10);
      sessionStorage.setItem('delegacionOrigen', deleg);
      setDelegacionOrigen(deleg);
      if (initialFiltersValue == null || initialFiltersValue.idDelegacion == 0) {
        handleChangeFilters('idDelegacion', deleg);
      }
    }
  }, [delegacionOrigenData]);

  const handleChangeFechaDesde = (value) => {
    const nuevaFecha = value ? moment(value).format("yyyy-MM-DD") : null;
    handleChangeFilters('fechaDesde', nuevaFecha);
  };

  const handleChangeFechaHasta = (value) => {
    const nuevaFecha = value ? moment(value).format("yyyy-MM-DD") : null;
    handleChangeFilters('fechaHasta', nuevaFecha);
  };

  const handleChange = (e) => {
    const { value, name } = e.target;
    handleChangeFilters([name], value);
  };

  const [getDocumentos, { data: documentosData, loading: documentosLoading }] = useLazyQuery(GET_DOCUMENTOS_SEARCH, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!documentosData) return;
    setDocumentos(adaptDocumentosSearchArray(documentosData));
    setDocumentosSinFiltro(adaptDocumentosSearchArray(documentosData));
    setDocumentosExport(adaptDocumentosSearchExportArray(documentosData));
  }, [documentosData]);

  const filtersValidos = () => {
    if (filters.fechaDesde == "") {
      toast.error("La Fecha Desde es obligatoria.");
      return false;
    }
    if (filters.fechaHasta == "") {
      toast.error("La Fecha Hasta es obligatoria.");
      return false;
    }
    if (filters.fechaHasta < filters.fechaDesde) {
      toast.error("La Fecha Hasta no puede ser anterior a la Fecha Desde.");
      return false;
    }

    return true;
  };

  const handleSearch = () => {
    if (!documentosLoading && filtersValidos()) {
      getDocumentos({
        variables: {
          filter: {
            idDelegacion: filters.idDelegacion,
            fechaDesde: filters.fechaDesde,
            fechaHasta: filters.fechaHasta,
            codCliente: filters.codigoCliente.toString(),
            codPaciente: filters.hcPaciente.toString(),
            pendienteFacturar: filters.pendienteFacturar,
            facturacionAutomatica: filters.facturacionAutomatica
          }
        }
      });
    }
  };

  const getChipColor = (estado, tooltip) => {
    if (estado != 'NC') {
      const estados = {
        'S': { isGreen: true },
        'O': { isYellow: true },
        'N': { isRed: true }
      };

      return <CustomChip
        label={estado}
        {...estados[estado]}
        title={tooltip} />;


    } else {
      return estado;
    }
  };

  const handleView = (row) => {
    navigate('/consultadoc/detalle',
    {
      state: {
        data: row,
        filters: localStorage.getItem('documentsSearchFilters') == null ? filters : JSON.parse(localStorage.getItem('documentsSearchFilters'))
      }
    });
  };

  const initialDocumentsColumns = [
  {
    headerName: '',
    field: 'action',
    width: 35,
    renderCell: (params) => {
      return (
        <AttachFileIcon className='edit-icon' sx={{ paddingTop: '7px' }} onClick={() => handleView(params.row)} />);
    }
  },
  { field: 'idEvaluacion', headerName: 'Eval.', width: 60 },
  { field: 'paciente', headerName: 'Paciente', width: 200 },
  { field: 'cliente', headerName: 'Cliente', width: 200 },
  {
    field: 'fechaDesde',
    headerName: 'Fec. Desde',
    width: 95,
    type: 'date'
  },
  {
    field: 'fechaHasta',
    headerName: 'Fec. Hasta',
    width: 95,
    type: 'date'
  },
  { field: 'modulo', headerName: 'Plan', width: 200 },
  { field: 'cantCnx', headerName: 'Cnt. Cx', width: 64, align: 'center' },
  { field: 'cantCnxPE', headerName: 'Cnx. PE', width: 68, align: 'center' },
  { field: 'cantCnxVE', headerName: 'Cnx. VE', width: 68, align: 'center' },
  {
    field: 'aC',
    headerName: 'AC',
    headerAlign: 'center',
    minWidth: 38,
    align: 'center',
    renderCell: ({ row }) => {
      return (
        getChipColor(row?.aC, 'Autorización de Servicio'));


    }
  },
  {
    field: 'eV',
    headerName: 'EV',
    headerAlign: 'center',
    minWidth: 37,
    align: 'center',
    renderCell: ({ row }) => {
      return (
        getChipColor(row?.eV, 'Evolución Médica'));
    }
  },  
  {
    field: 'c',
    headerName: 'C',
    headerAlign: 'center',
    minWidth: 28,
    align: 'center',
    renderCell: ({ row }) => {
      return (
        getChipColor(row?.c, 'Conformidad del Paciente'));


    }
  },
  {
    field: 'rNH',
    headerName: 'RNH',
    headerAlign: 'center',
    align: 'center',
    minWidth: 48,
    renderCell: ({ row }) => {
      return (
        getChipColor(row?.rNH, 'Remito NH'));


    }
  },
  {
    field: 'rFK',
    headerName: 'RFK',
    headerAlign: 'center',
    align: 'center',
    minWidth: 48,
    renderCell: ({ row }) => {
      return (
        getChipColor(row?.rFK, 'Remito FK'));


    }
  },
  {
    field: 'p',
    headerName: 'P',
    headerAlign: 'center',
    minWidth: 28,
    align: 'center',
    renderCell: ({ row }) => {
      return (
        getChipColor(row?.p, 'Prescripción'));


    }
  },
  {
    field: 'v',
    headerName: 'V',
    headerAlign: 'center',
    minWidth: 28,
    align: 'center',
    renderCell: ({ row }) => {
      return (
        getChipColor(row?.v, 'Validación'));


    }
  },
  {
    field: 'dOC',
    headerName: 'DOC',
    headerAlign: 'center',
    minWidth: 49,
    align: 'center',
    renderCell: ({ row }) => {
      return (
        getChipColor(row?.dOC, 'Documentación Paciente'));


    }
  },
  {
    field: 'pE',
    headerName: 'PE',
    headerAlign: 'center',
    minWidth: 37,
    align: 'center',
    renderCell: ({ row }) => {
      return (
        getChipColor(row?.pE, 'Enfermería'));


    }
  },
  {
    field: 'pG',
    headerName: 'PG',
    minWidth: 39,
    headerAlign: 'center',
    align: 'center',
    renderCell: ({ row }) => {
      return (
        getChipColor(row?.pG, 'Enfermería Guardia CP'));


    }
  },
  {
    field: 'nT',
    headerName: 'NT',
    headerAlign: 'center',
    minWidth: 37,
    align: 'center',
    renderCell: ({ row }) => {
      return (
        getChipColor(row?.nT, 'Nutricionista'));


    }
  },
  {
    field: 'fN',
    headerName: 'FN',
    headerAlign: 'center',
    minWidth: 37,
    align: 'center',
    renderCell: ({ row }) => {
      return (
        getChipColor(row?.fN, 'Fonoaudiólogo'));


    }
  },
  {
    field: 'pS',
    headerName: 'PS',
    headerAlign: 'center',
    minWidth: 37,
    align: 'center',
    renderCell: ({ row }) => {
      return (
        getChipColor(row?.pS, 'Psicólogo'));


    }
  },
  {
    field: 'kN',
    headerName: 'KN',
    headerAlign: 'center',
    minWidth: 38,
    align: 'center',
    renderCell: ({ row }) => {
      return (
        getChipColor(row?.kN, 'Kinesiólogo'));
    }
  },
  {
    field: 'tOC',
    headerName: 'TOC',
    headerAlign: 'center',
    minWidth: 48,
    align: 'center',
    renderCell: ({ row }) => {
      return (
        getChipColor(row?.tOC, 'Terapista Ocupacional'));


    }
  },
  {
    field: 'aSS',
    headerName: 'AS',
    headerAlign: 'center',
    minWidth: 37,
    align: 'center',
    renderCell: ({ row }) => {
      return (
        getChipColor(row?.aSS, 'Asistente Social'));


    }
  },
  {
    field: 'pSI',
    headerName: 'PSI',
    headerAlign: 'center',
    align: 'center',
    minWidth: 48,
    renderCell: ({ row }) => {
      return (
        getChipColor(row?.pSI, 'Psiquiatra'));


    }
  }];


  const columnsDocuments = useMemo(() => generateColumnsDefaultConfiguration(initialDocumentsColumns, true), []);

  useEffect(() => {
    setChildrenAction(() =>
    <div className='documentos-all'>
                <CustomButton
        variant='outlined'
        className='margin-right'
        onClick={handleDownloadExcel}
        disabled={documentosExport == null || documentosExport.length <= 0}>
        
                    Exportar
                </CustomButton>
            </div>
    );
  }, [setChildrenAction, documentosExport]);

  const handleDownloadExcel = () => {
    downloadExcel({
      fileName: 'ConsultaDocumentacion',
      sheet: "Documentos",
      tablePayload: {
        header,
        body: documentosExport
      }
    });
  };

  const handleChangePendiente = (e) => {
    handleChangeFilters('pendienteFacturar', e.target.checked);
  };

  const handleChangeFacturacion = (e) => {
    handleChangeFilters('facturacionAutomatica', e.target.checked);
  };

  const handleFilterGrid = () => {
    if (txtFiltroGrilla.current.value != "") {
      if (txtFiltroGrilla.current.value.length >= 2) {
        setDocumentos(documentosSinFiltro.filter((documentosSinFiltro) => {
          const evaluacionBuscar = documentosSinFiltro.idEvaluacion.toString().toUpperCase();
          const pacienteBuscar = documentosSinFiltro.paciente.toUpperCase();
          const clienteBuscar = documentosSinFiltro.cliente.toUpperCase();
          const planBuscar = documentosSinFiltro.modulo.toUpperCase();

          const inputBuscar = txtFiltroGrilla.current.value.toUpperCase();
          return (
            evaluacionBuscar.includes(inputBuscar) ||
            pacienteBuscar.includes(inputBuscar) ||
            clienteBuscar.includes(inputBuscar) ||
            planBuscar.includes(inputBuscar));

        }
        ));
      }
    } else {
      setDocumentos(documentosSinFiltro);
    }
  };

  return (
    <>
            
            <div>
                <Grid
          container
          spacing={2}
          sx={{ marginBottom: '15px' }}>
          
                    <Grid size={{ md: 3 }}>
                        <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                            <InputLabel id="select-delegacion">Delegación</InputLabel>
                            <Select
                labelId="select-delegacion"
                options={delegaciones}
                label='Delegación'
                onChange={handleChange}
                value={filters?.idDelegacion}
                name='idDelegacion'>
                
                                {delegaciones && delegaciones.map((delegacion) => {
                  return <MenuItem value={delegacion.id}> {delegacion.displayName} </MenuItem>;
                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={{ md: 2 }}>
                        <DateInput
              label="Fecha Desde"
              className='date-input-new'
              value={filters?.fechaDesde}
              onChange={handleChangeFechaDesde} />
            
                    </Grid>
                    <Grid size={{ md: 2 }}>
                        <DateInput
              label="Fecha Hasta"
              className='date-input-new'
              value={filters?.fechaHasta}
              onChange={handleChangeFechaHasta} />
            
                    </Grid>
                    <Grid size={{ md: 4 }}>
                        <div style={{ display: 'flex', width: '100%' }}>
                            <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                                <div style={{ display: 'flex', width: '100%' }}>
                                    <TextField
                    label="Filtrar"
                    name="txtFiltroGrilla"
                    size="small"
                    type="text"
                    variant="outlined"
                    inputRef={txtFiltroGrilla}
                    onKeyUp={handleFilterGrid}
                    sx={{ backgroundColor: 'white', width: '100%' }}
                    InputProps={{
                      endAdornment:
                      <InputAdornment position="end">
                                                    <SearchIcon
                          onClick={handleFilterGrid}
                          sx={{ cursor: 'pointer' }} />
                        
                                                </InputAdornment>

                    }} />
                  
                                </div>
                            </FormControl>
                        </div>
                    </Grid>
                    <Grid sx={{ textAlign: 'right' }} size={{ md: 1 }}>
                        <CustomButton
              variant='contained'
              className='margin-right'
              onClick={handleSearch}
              size='small'>
              
                            Buscar
                        </CustomButton>
                    </Grid>
                </Grid>
                <Grid
          container
          spacing={2}
          sx={{ marginBottom: '0px' }}>
          
                    <Grid size={{ md: 2 }}>
                        <Checkbox
              checked={filters?.pendienteFacturar}
              onChange={handleChangePendiente}
              value={filters?.pendienteFacturar} />
            
                        Pendiente facturar
                    </Grid>
                    <Grid size={{ md: 2 }}>
                        <Checkbox
              checked={filters?.facturacionAutomatica}
              onChange={handleChangeFacturacion}
              value={filters?.facturacionAutomatica} />
            
                        Facturación automática
                    </Grid>
                </Grid>
                <br />
                <DataGridGenerico
          columns={columnsDocuments}
          rows={documentos}
          toolbar={false}
          loading={documentosLoading} />
        

                <div className='card-container' style={{ marginTop: '20px' }}>
                    <Grid
            container
            justifyContent={'flex-start'}
            rowGap={1}>
            
                        <Grid size={{ md: 12 }}>
                            <div className='titulo-seccion'>Referencias</div>
                        </Grid>
                        <Grid size={{ md: 12 }}>
                            <strong>AC:</strong> Autorizacion de Servicio, <strong>EV:</strong> Evolución Médica, <strong>C:</strong> Conformidad del paciente, <strong>RNH:</strong> Remito NH, <strong>RFK: </strong> Remito FK, <strong>P:</strong> Prescripcion, <strong>V:</strong> Validacion, <strong>DOC:</strong> Doc. Paciente, <strong>PE:</strong> Enfermeria
                        </Grid>
                        <Grid size={{ md: 12 }}>
                            <strong>PG:</strong> Enfermeria Guardia CP, <strong>NT:</strong> Nutricionista, <strong>FN:</strong> Fonoaudiólogo, <strong>PS:</strong> Psicologo, <strong>KN:</strong> Kinesiologo, <strong>TOC:</strong> Terapista Ocupacional, <strong>AS:</strong> Asistente Social, {/*<strong>EV:</strong> Ev. Medica, <strong>RCP:</strong> Registro Asitencia Medico CP,*/} <strong>PSI:</strong> Psiquiatra
                        </Grid>
                        <Grid size={{ md: 12 }}>
                            <strong>S:</strong> SI, <strong>N:</strong> NO, <strong>O:</strong> Opcional <strong>NC:</strong> No Corresponde
                        </Grid>
                        <Grid size={{ md: 12 }}>
                            <strong>RNH=O:</strong> El cliente requiere remito y no posee envio. Generar minuta de forma manual.
                        </Grid>
                    </Grid>
                </div>
            </div>
        </>);

};